import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "check-1_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#check-1_a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M23.374.287a1.5 1.5 0 0 0-2.093.345L7.246 20.2l-4.685-4.689a1.5 1.5 0 0 0-2.122 2.121l5.935 5.934a1.525 1.525 0 0 0 2.279-.186l15.066-21a1.5 1.5 0 0 0-.345-2.093" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "check-1_a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" })
	}) })]
});
export { SvgCheck1 as ReactComponent };
